export enum BlendingName {
  Additive = 'AdditiveBlending',
  Custom = 'CustomBlending',
  Multiply = 'MultiplyBlending',
  None = 'NoBlending',
  Normal = 'NormalBlending',
  Subtractive = 'SubtractiveBlending'
}
